export const convertYenToMmk = (yenAmount, exchangeRate) => {
    const mmkAmount = yenAmount * exchangeRate;
    const truncatedNumber = mmkAmount.toFixed()
    return truncatedNumber.slice(0,-5)
};
  